import { TableColumn } from '@shared/components/data-table/data-table.component';

export const LOT_BARCODE_DEFAULT_COLUMNS = {
  SKU_CODE: 'skuCode',
  SKU_NAME: 'skuName',
  LOT_VALUE: 'lotValue',
  EXPIRY_DATE: 'expiryDate',
  BARCODE_PREVIEW: 'barcodePreview',
} as const;

export const LOT_BARCODE_DEFAULT_COLUMNS_ORDER: string[] = [
  LOT_BARCODE_DEFAULT_COLUMNS.SKU_CODE,
  LOT_BARCODE_DEFAULT_COLUMNS.SKU_NAME,
  LOT_BARCODE_DEFAULT_COLUMNS.LOT_VALUE,
  LOT_BARCODE_DEFAULT_COLUMNS.EXPIRY_DATE,
  LOT_BARCODE_DEFAULT_COLUMNS.BARCODE_PREVIEW,
];

export const LOT_BARCODE_FLEXIBLE_COLUMNS = {
  PRODUCT_CODE: 'productCode',
  SOURCE_BATCH_ID: 'sourceBatchId',
} as const;

export const LOT_BARCODE_FLEXIBLE_COLUMNS_ORDER: string[] = [
  LOT_BARCODE_FLEXIBLE_COLUMNS.PRODUCT_CODE,
  LOT_BARCODE_FLEXIBLE_COLUMNS.SOURCE_BATCH_ID,
];

export const LOT_BARCODE_COLUMNS: TableColumn[] = [
  {
    label: 'lot_barcode.table.sku_code',
    prop: LOT_BARCODE_DEFAULT_COLUMNS.SKU_CODE,
    width: 140,
  },
  {
    label: 'lot_barcode.table.sku_name',
    prop: LOT_BARCODE_DEFAULT_COLUMNS.SKU_NAME,
    width: 200,
  },
  {
    label: 'lot_barcode.table.lot_value',
    prop: LOT_BARCODE_DEFAULT_COLUMNS.LOT_VALUE,
    width: 140,
  },
  {
    label: 'lot_barcode.table.expiry_date',
    prop: LOT_BARCODE_DEFAULT_COLUMNS.EXPIRY_DATE,
    width: 130,
    type: 'custom',
  },
  {
    label: 'lot_barcode.table.barcode_preview',
    prop: LOT_BARCODE_DEFAULT_COLUMNS.BARCODE_PREVIEW,
    width: 260,
    type: 'custom',
  },
  {
    label: 'lot_barcode.table.product_code',
    prop: LOT_BARCODE_FLEXIBLE_COLUMNS.PRODUCT_CODE,
    width: 140,
  },
  {
    label: 'lot_barcode.table.source_batch_id',
    prop: LOT_BARCODE_FLEXIBLE_COLUMNS.SOURCE_BATCH_ID,
    width: 120,
  },
];
